export default "__VITE_ASSET__BnQnNPdS__"